import { useState } from 'react';
import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { guomanComics, rimanComics } from '@/mocks/comics';

type TabKey = 'guoman' | 'riman';

export default function HotSection() {
  const [tab, setTab] = useState<TabKey>('guoman');
  const list = tab === 'guoman' ? guomanComics.slice(0, 4) : rimanComics.slice(0, 4);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门<span className="text-primary-500">连载</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">高人气、高口碑，大家都在追的作品</p>
          </div>
          <div className="inline-flex items-center rounded-full border border-background-200 bg-background-50 p-1">
            {(['guoman', 'riman'] as TabKey[]).map((key) => (
              <button
                key={key}
                type="button"
                onClick={() => setTab(key)}
                className={`rounded-full px-5 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  tab === key ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {key === 'guoman' ? '国漫' : '日漫'}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-4">
          {list.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to={tab === 'guoman' ? '/guoman' : '/riman'}
            className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-6 py-2.5 text-sm font-medium text-primary-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
          >
            查看全部{tab === 'guoman' ? '国漫' : '日漫'} <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}